import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=45033b8e&"
import script from "./Carousel.vue?vue&type=script&lang=ts&"
export * from "./Carousel.vue?vue&type=script&lang=ts&"
import style0 from "./Carousel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports